import {useEffect} from 'react';
import {useLocation} from 'react-router-dom';
import {useLang} from '@/i18n/LangContext';
import {useAuth} from '@/portal/AuthContext';
import {api} from '@/lib/api';
import {createCanvas,EMPTY} from './canvas';

export default function SiteCanvas() {
  const {pathname, search} = useLocation();
  const {lang} = useLang();
  const {user} = useAuth();
  const editing = new URLSearchParams(search).get('site-edit') === '1';
  const authorized = editing && user?.role === 'admin' && user?.admin_level === 'owner';
  useEffect(() => {
    if (/^\/(admin|kundenbereich|workspace)(\/|$)/.test(pathname)) return;
    if (editing && !authorized) return;
    let canvas, cancelled = false,viewContent=EMPTY;
    const send = (type, payload) => window.parent.postMessage({type, ...payload}, window.location.origin);
    const receive = event => {
      if(event.origin!==window.location.origin||event.source!==window.parent)return;
      if(event.data?.type==='CMS_PREVIEW'){viewContent=event.data.content;canvas?.apply(viewContent);}
      if(event.data?.type==='CMS_SHARED_PREVIEW')canvas?.apply(viewContent,{shared:event.data.blocks});
    };
    const start = async () => {
      try {
        const [publicResponse,draftResponse] = await Promise.all([api.get('/site-editor/published',{params:{path:pathname,lang}}),editing?api.get('/site-editor/document',{params:{path:pathname,lang}}):Promise.resolve(null)]);
        const data=publicResponse.data;
        if (cancelled) return;
        if (!editing && !data.content && !data.finder_rules?.length && !data.shared_blocks?.length) return;
        canvas = createCanvas(document, {editing, onSelect: selected => send('CMS_SELECT', {selected}), onSections: sections => editing && send('CMS_SECTIONS', {sections})});
        viewContent=(editing?draftResponse.data.draft:data.content)||EMPTY;
        canvas.apply(viewContent,{rules:data.finder_rules||[],shared:data.shared_blocks||[],themeEnabled:editing||!!data.content});
        if (editing) send('CMS_READY', {});
      } catch { if (editing && !cancelled) send('CMS_ERROR', {}); }
    };
    window.addEventListener('message', receive);
    start();
    return () => {cancelled = true; canvas?.dispose(); window.removeEventListener('message', receive);};
  }, [pathname, lang, editing, authorized]);
  return null;
}

export const CustomSitePage = () => <div className="cms-custom-page" style={{minHeight: '60vh', paddingTop: 140}}><section className="heritage-section"><h1>Новая страница</h1><p>Добавьте содержание в редакторе сайта.</p></section></div>;
